import { debounce } from "@sazka/utils/debounce";
import { documentReady } from "@sazka/utils/document-ready";

const initContextMenu = (breadcrumbsElement: HTMLElement) => {
    const contextMenu = breadcrumbsElement.querySelector(".ds-breadcrumbs__context-menu");
    const contextMenuToggleButton = contextMenu.querySelector(".ds-breadcrumbs__toggle");
    contextMenuToggleButton.addEventListener("click", () => {
        contextMenu.classList.toggle("menu-open");
    });
};

const handleBreadcrumbsShortening = (breadcrumbsElement: HTMLElement, breadcrumbsItems: HTMLElement[]) => {
    const homeItem = breadcrumbsItems[0];
    const contextMenuItem = breadcrumbsItems[1];
    const currentPageParentItem = breadcrumbsItems[breadcrumbsItems.length - 2];
    const currentPageItem = breadcrumbsItems[breadcrumbsItems.length - 1];

    const contextMenuItems = contextMenuItem.querySelectorAll<HTMLElement>(".ds-breadcrumbs__context-dialog__item");
    const contextMenuParentPageItem = contextMenuItems[contextMenuItems.length - 1];

    // show all items to calculate width
    breadcrumbsItems.forEach((i) => (i.style.display = "flex"));
    contextMenuItems.forEach((i) => (i.style.display = "block"));
    currentPageItem.style.overflow = "unset";

    const containterWidth = breadcrumbsElement.offsetWidth;
    const totalItemsWidth = breadcrumbsItems
        .filter((i) => i !== contextMenuItem)
        .map((i) => i.offsetWidth)
        .reduce((a, b) => a + b, 0);

    // if all page items fit, hide context menu
    if (totalItemsWidth < containterWidth) {
        contextMenuItem.style.display = "none";
        return;
    }

    // if current page and parent fit, show those and context menu without parent
    if (
        homeItem.offsetWidth +
            contextMenuItem.offsetWidth +
            currentPageParentItem.offsetWidth +
            currentPageItem.offsetWidth <
        containterWidth
    ) {
        breadcrumbsItems.forEach((i) => {
            if (i !== homeItem && i !== contextMenuItem && i !== currentPageParentItem && i !== currentPageItem) {
                i.style.display = "none";
            }
        });

        contextMenuParentPageItem.style.display = "none";

        return;
    }

    // otherwise show only current page and context menu
    breadcrumbsItems.forEach((i) => {
        if (i !== homeItem && i !== contextMenuItem && i !== currentPageItem) {
            i.style.display = "none";
        }
    });

    currentPageItem.style.overflow = "hidden";
};

const initBreadcrumbs = (breadcrumbsElement: HTMLElement) => {
    const breadcrumbsItems = breadcrumbsElement.querySelectorAll<HTMLElement>(".ds-breadcrumbs__item");

    // if breadcrumbs only have two items they stay as they are
    if (breadcrumbsItems.length < 3) {
        return;
    }

    initContextMenu(breadcrumbsElement);
    handleBreadcrumbsShortening(breadcrumbsElement, [...breadcrumbsItems]);

    window.addEventListener(
        "resize",
        debounce(() => {
            handleBreadcrumbsShortening(breadcrumbsElement, [...breadcrumbsItems]);
        }, 150),
        { passive: true }
    );
};

documentReady(() => {
    const breadcrumbsElements = document.querySelectorAll<HTMLElement>(".ds-breadcrumbs");

    breadcrumbsElements.forEach((b) => initBreadcrumbs(b));
});
